export default "__VITE_ASSET__8d48927e__"